export default __webpack_public_path__ + "static/media/fartguy.a2a211c3.mp4";